import { render, staticRenderFns } from "./CustomerMappingsPreviewTable.vue?vue&type=template&id=4df829c8&scoped=true&"
import script from "./CustomerMappingsPreviewTable.vue?vue&type=script&lang=js&"
export * from "./CustomerMappingsPreviewTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMappingsPreviewTable.vue?vue&type=style&index=0&id=4df829c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df829c8",
  null
  
)

export default component.exports